import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Other Details tabs component for switching between Noteworthy Events and Personal Details
 * @param {Object} props - Component props
 * @param {Array} props.tabs - Array of tab objects with label and key
 * @param {string} props.activeTab - Key of the currently active tab
 * @param {Function} props.onTabClick - Callback when tab is clicked
 */
const OtherDetailsTabs = ({ tabs, activeTab, onTabClick }) => {
  // If only one tab, show as heading instead
  if (tabs.length === 1) {
    // Convert "NOTEWORTHY EVENTS" to "Noteworthy Events"
    const headingText = tabs[0].label
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');

    return (
      <div className="other-details-tabs">
        <div className="other-details-tabs--heading">{headingText}</div>
      </div>
    );
  }

  return (
    <div className="other-details-tabs">
      <div className="other-details-tabs--list">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={classNames('other-details-tabs--tab', {
              'other-details-tabs--tab-active': tab.key === activeTab,
            })}
            onClick={() => onTabClick(tab.key)}
            type="button"
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

OtherDetailsTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabClick: PropTypes.func.isRequired,
};

export default OtherDetailsTabs;
